import { render, staticRenderFns } from "./SupporterEditDetails.vue?vue&type=template&id=4ab736b1&"
import script from "./SupporterEditDetails.vue?vue&type=script&lang=js&"
export * from "./SupporterEditDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ab736b1')) {
      api.createRecord('4ab736b1', component.options)
    } else {
      api.reload('4ab736b1', component.options)
    }
    module.hot.accept("./SupporterEditDetails.vue?vue&type=template&id=4ab736b1&", function () {
      api.rerender('4ab736b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/supporters/views/Details/SupporterEditDetails.vue"
export default component.exports